export const RESORT_DISCOVERY_DEFAULTS = {
  emailTitle: '{{hotelName}} Is Waiting For You',
  ctaText: 'Book Now',
  ctaBackgroundColor: '#1e4b7a',
  ctaTextColor: '#ffffff',
  logoWidth: '120px',
  logoHeight: '120px',
  footerLogoWidth: '120px',
  galleryKicker: '',
  galleryTitle: 'Discover {{hotelName}}',
  discoverIntroText:
    'This is your open invitation to discover the experiences waiting for you at {{hotelName}}.',
  discoverBtn1: 'Explore Flavors',
  discoverBtn2: 'Experience Events',
  discoverBtn3: 'Celebrate Birdies',
  discoverBtn4: 'Discover Tranquility',
  hotelName: '',
  hotelAddress: '',
  hotelCityStateZip: '',
  hotelPhone: '',
  hotelWebsite: '',
  hotelWebsiteUrl: '',
  richtextFields: {
    bodyHtml: `Dear :token{key="guestName" label="First name"},

Still interested in planning your next getaway? Book your dates while they are still available, and be sure to take advantage of our latest **special offers and seasonal packages**.

Check In Date: :token{key="checkinDate" label="Check-in date"}`
  }
}

export default RESORT_DISCOVERY_DEFAULTS
